module.exports = __webpack_public_path__ + "img/tv1.dfc0f20c.gif";